import script from "./PaymentDiscountPolicyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDiscountPolicyPanel.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDiscountPolicyPanel.vue?vue&type=style&index=0&id=36db8dfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36db8dfc"]])

export default __exports__